import script from "./editModal.vue?vue&type=script&setup=true&lang=js"
export * from "./editModal.vue?vue&type=script&setup=true&lang=js"

import "./editModal.vue?vue&type=style&index=0&id=3111c1be&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3111c1be"]])

export default __exports__